<script setup lang="ts">
import { BButton, type ButtonVariant, type Size } from 'bootstrap-vue-next'
defineProps<{
  size?: Size
  variant?: ButtonVariant | null
  disabled?: boolean
  pill?: boolean
  loading?: boolean
  loadingText?: string
}>()
</script>

<template>
  <BButton
    :variant="variant ? variant : 'secondary'"
    :size="size"
    :disabled="disabled"
    :class="[`btn-${variant ? variant : 'secondary'}`]"
    :pill="pill"
    :loading="loading"
    :loading-text="loadingText"
  >
    <slot></slot>
  </BButton>
</template>

<style lang="scss" scoped>
.btn- {
  &sm {
    padding: 0.5rem 0.5rem;
    font-size: 1rem;
    border-radius: 0.2rem;
  }

  &md {
    padding: 0.5rem 1rem;
    font-size: 1.5rem;
    border-radius: 0.4rem;
  }

  &lg {
    padding: 0.5rem 1.5rem;
    font-size: 2rem;
    border-radius: 0.8rem;
  }

  &primary {
    background-color: $primary;
    border-color: $primary;

    &:hover {
      background-color: $primary-hover;
      border-color: $primary-hover;
    }

    &:active {
      background-color: $primary-hover;
      border-color: $primary-hover;
    }
  }

  &outline-primary {
    background-color: initial;
    border-color: $primary;
    color: $primary;

    &:hover {
      background-color: $primary-hover;
      border-color: $primary-hover;
      color: #ffffff !important;
    }

    &:active {
      background-color: $primary-hover;
      border-color: $primary-hover;
      color: #ffffff !important;
    }
  }

  &secondary {
    background-color: $secondary;
    border-color: $secondary;

    &:hover {
      background-color: $secondary-hover;
      border-color: $secondary-hover;
    }

    &:active {
      background-color: $secondary-hover;
      border-color: $secondary-hover;
    }
  }

  &outline-secondary {
    background-color: initial;
    border-color: $secondary;
    color: $secondary;

    &:hover {
      background-color: $secondary-hover;
      border-color: $secondary-hover;
      color: #ffffff !important;
    }

    &:active {
      background-color: $secondary-hover;
      border-color: $secondary-hover;
      color: #ffffff !important;
    }
  }

  &danger {
    background-color: $danger;
    border-color: $danger;

    &:hover {
      background-color: $danger-hover;
      border-color: $danger-hover;
    }

    &:active {
      background-color: $danger-hover;
      border-color: $danger-hover;
    }
  }

  &outline-danger {
    background-color: initial;
    border-color: $danger;
    color: $danger;

    &:hover {
      background-color: $danger-hover;
      border-color: $danger-hover;
      color: #ffffff !important;
    }

    &:active {
      background-color: $danger-hover;
      border-color: $danger-hover;
      color: #ffffff !important;
    }
  }

  &success {
    background-color: $success;
    border-color: $success;

    &:hover {
      background-color: $success-hover;
      border-color: $success-hover;
    }

    &:active {
      background-color: $success-hover;
      border-color: $success-hover;
    }
  }

  &outline-success {
    background-color: initial;
    border-color: $success;
    color: $success;

    &:hover {
      background-color: $success-hover;
      border-color: $success-hover;
      color: #ffffff !important;
    }

    &:active {
      background-color: $success-hover;
      border-color: $success-hover;
      color: #ffffff !important;
    }
  }
}
</style>
